import { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { alpha } from '@classify/react-core-components/styles';
import InvertedCIcon from './InvertedCIcon';
import ThumbnailSize from '../../../constants/ThumbnailSize';
import courseContext from '../../../contexts/courseContext';
import HeroVideo from '../HeroVideo';
import HeroImage from '../HeroImage';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: spacing(3),
    justifyContent: 'center',
    [breakpoints.up('sm')]: {
      marginBottom: 'unset',
      justifyContent: 'flex-end',
    },
  },
  icon: {
    marginRight: `-${ThumbnailSize.Default / 3}px`,
    [breakpoints.up('sm')]: {
      marginRight: `-${ThumbnailSize.OverSm / 3}px`,
    },
    [breakpoints.up('md')]: {
      marginRight: `-${ThumbnailSize.OverMd / 3}px`,
    },
    [breakpoints.up('lg')]: {
      marginRight: `-${ThumbnailSize.OverXl / 3}px`,
    },
    '& svg': {
      height: ThumbnailSize.Default,
      [breakpoints.up('sm')]: {
        height: ThumbnailSize.OverSm,
      },
      [breakpoints.up('md')]: {
        height: ThumbnailSize.OverMd,
      },
      [breakpoints.up('lg')]: {
        height: ThumbnailSize.OverXl,
      },
    },
  },
}));

function CourseHeroAsset() {
  const classes = useStyles();
  const { course } = useContext(courseContext);
  const { teaserUrl, title, illustration } = course;
  const iconBackgroundColor = alpha(course.categoryColor, 0.16);

  return (
    <div className={classes.wrapper}>
      <div className={classes.icon} aria-hidden>
        <InvertedCIcon fill={iconBackgroundColor} />
      </div>
      <div>
        {teaserUrl ? (
          <HeroVideo url={teaserUrl} title={title} fallbackImgUrl={illustration} />
        ) : (
          <HeroImage src={illustration} />
        )}
      </div>
    </div>
  );
}

export default CourseHeroAsset;
